/* eslint-disable @next/next/no-img-element */
"use client";
import Image from "next/image";
import Button from "../Button/page";

const Slider = ({ path, content }) => {
    const breakIntoLines = (text, maxFirstLineLength = 50) => {
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";

        for (let word of words) {
            if (
                currentLine.length + word.length + 1 <= maxFirstLineLength ||
                lines.length > 0
            ) {
                currentLine += (currentLine ? " " : "") + word;
            } else {
                lines.push(currentLine);
                currentLine = word;
            }
        }

        if (currentLine) {
            lines.push(currentLine);
        }

        // Adjust lines to ensure each subsequent line is shorter than the previous one
        for (let i = 1; i < lines.length; i++) {
            while (lines[i].length >= lines[i - 1].length) {
                let lastSpaceIndex = lines[i - 1].lastIndexOf(" ");
                if (lastSpaceIndex === -1) break;
                lines[i - 1] = lines[i - 1].slice(0, lastSpaceIndex);
            }
        }

        return lines;
    };

    return (
        <div className="relative w-full h-screen overflow-hidden">
            <Image
                src={`/assets/${path}/${content[0]?.bgImage}.webp`}
                alt={`/assets/${path}/${content[0]?.alt}`}
                fill
                style={{
                    objectFit: "cover",
                }}
            />

            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-center text-white p-5 ">
                <h2 className="text-2xl lg:text-5xl !leading-snug font-semibold font-manrope flex flex-col justify-center items-center">
                    {breakIntoLines(content[0]?.title).map(
                        (line, lineIndex) => (
                            <span
                                key={lineIndex}
                                // className="bg-black/70 my-1 px-2 rounded"
                            >
                                {line}
                            </span>
                        )
                    )}
                </h2>
                <div className="mt-10 flex justify-center">
                    <Button className="common-white-button-style">
                        {content[0]?.buttonName && content[0]?.buttonName}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Slider;
